import type { FC } from 'react';

import type { DataEntryStepProps } from '@/sections/seeds/components/modals/AddSeedByTypeModal/AddSeedByTypeModal.types';
import { AddDomainCidrForm } from '@/sections/seeds/components/modals/AddSeedByTypeModal/forms/AddDomainCidrForm';
import { AddWebApplicationForm } from '@/sections/seeds/components/modals/AddSeedByTypeModal/forms/AddWebApplicationForm';
import { AddWebServiceForm } from '@/sections/seeds/components/modals/AddSeedByTypeModal/forms/AddWebServiceForm';
import { SeedTypeOption } from '@/types';

/**
 * Step 2: Data Entry
 *
 * Renders the appropriate form based on the selected seed type.
 * Handles text input and Import button click.
 */
export const DataEntryStep: FC<DataEntryStepProps> = ({
  formData,
  onTextChange,
  onOpenImport,
}) => {
  switch (formData.seedType) {
    case SeedTypeOption.DOMAIN_CIDR:
      return (
        <AddDomainCidrForm
          textInput={formData.textInput}
          onTextChange={onTextChange}
          onOpenImport={onOpenImport}
        />
      );

    case SeedTypeOption.WEB_APPLICATION:
      return (
        <AddWebApplicationForm
          textInput={formData.textInput}
          onTextChange={onTextChange}
          onOpenImport={onOpenImport}
        />
      );

    case SeedTypeOption.WEB_SERVICE:
      return (
        <AddWebServiceForm
          textInput={formData.textInput}
          onTextChange={onTextChange}
        />
      );

    default:
      return null;
  }
};
